import { render } from "./InDev.vue?vue&type=template&id=e2224c16&scoped=true"
import script from "./InDev.vue?vue&type=script&lang=js"
export * from "./InDev.vue?vue&type=script&lang=js"

import "./InDev.vue?vue&type=style&index=0&id=e2224c16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2224c16"]])

export default __exports__